import { mapRequiredStringValue, stringToDate, translate } from "@klantondersteuning-btl/shared";
import { EhicFormulierSchemaModel } from "../schema/EhicFormulier";
import { EhicAanvragenCommand } from "@klantondersteuning-btl/client";

export class SchemaToRequestMapper {
  map = (klachtenformulier: EhicFormulierSchemaModel): EhicAanvragenCommand => {
    const request = new EhicAanvragenCommand();

    request.email = mapRequiredStringValue(klachtenformulier.contactgegevens.emailAdres);
    request.cakIdNummer = mapRequiredStringValue(klachtenformulier.persoonlijkDossier.CAKIDnummer);
    
    if (klachtenformulier.persoonlijkDossier.geboorteDatum) {
      request.geboortedatum = stringToDate(klachtenformulier.persoonlijkDossier.geboorteDatum);
    } else {
      throw new Error(translate("VerplichtVeldIsNietIngevuldTijdensVerzenden"));
    }

    return request;
  };
}
